<template>

	<v-form @submit.prevent ref="form">
		<v-container fluid>
			<v-row>
				<v-col cols="12" sm="6">
					<v-autocomplete
						:items="types"
						v-model="fields.type"
						:label="$t('deliveries.header.type') + '*'"
						:rules="rules.required"
						required
						color="#3200E6"
						cache-items
						clearable
					/>
				</v-col>
				<v-col cols="12" sm="6">
					<v-text-field color="#3200E6" v-model="fields.product" :label="$t('deliveries.header.product') + '*'" :rules="rules.required" required></v-text-field>
				</v-col>
				<v-col cols="12" sm="6">
					<v-text-field color="#3200E6" v-model="fields.group" :label="$t('deliveries.header.group') + '*'" :rules="rules.required" required></v-text-field>
				</v-col>
				<v-col cols="12" sm="6">
					<v-text-field color="#3200E6" v-model="fields.ASN" :label="$t('deliveries.header.ASN') + '*'" :rules="rules.required" required></v-text-field>
				</v-col>
				<v-col cols="12" sm="6">
					<v-text-field color="#3200E6" v-model="fields.PO" :label="$t('deliveries.header.PO') + '*'" :rules="rules.required" required></v-text-field>
				</v-col>
				<v-col cols="12" sm="6">
					<v-text-field color="#3200E6" v-model="fields.origin" :label="$t('deliveries.header.origin') + '*'" :rules="rules.required" required></v-text-field>
				</v-col>

				<v-col cols="12" sm="6">
					<v-dialog
						ref="dialog"
						v-model="modal"
						:return-value.sync="date"
						width="290px"
					>
						<template v-slot:activator="{ on, attrs }">
							<v-text-field
								v-model="dateInput"
								:label="$t('deliveries.header.estimated_reception_date') + '*'"
								v-bind="attrs"
								v-on="on"
								:rules="rules.required"
								required
								color="#3200E6"
								@blur="date = parseDateInput(dateInput)"
							></v-text-field>
						</template>
						<v-date-picker
							v-model="date"
							scrollable
							:min="today"
							color="#3200E6"
						>
							<v-spacer></v-spacer>
							<v-btn
								text
								color="#3200E6"
								@click="modal = false"
							>
								Cancel
							</v-btn>
							<v-btn
								text
								color="#3200E6"
								@click="$refs.dialog.save(date)"
							>
								OK
							</v-btn>
						</v-date-picker>
					</v-dialog>
				</v-col>
			</v-row>
			<v-btn
				:disabled="!isValid"
				class="action"
				@click="submit">
				{{ $t('deliveries.buttons.add') }}
			</v-btn>
			<v-btn
				class="cancel"
				@click="clearForm">
				{{ $t('deliveries.buttons.clear') }}
			</v-btn>
		</v-container>
	</v-form>

</template>

<script>
import Vue from 'vue';
import { mapGetters } from 'vuex';
import { formatDate, parseDate } from '@/utils/helpers';
import { api } from '@/utils/api';

export default {
	name: 'Create',
	props: ['opened', 'type'],
	data () {
		const newDate = new Date().toISOString().substr(0, 10);
		return {
			modal: false,
			date: newDate,
			dateInput: formatDate(newDate),
			today: newDate,
			rules: {
				required: [val => (val || '').length > 0 || this.$t('forms.errors.required')]
			},
			types: ['NIN', 'NCN'],
			fields: {
				type: this.type,
				product: '',
				group: '',
				ASN: '',
				PO: '',
				origin: '',
				estimated_reception_date: (+new Date())
			}
		};
	},

	computed: {
		...mapGetters(['getClientName', 'getServiceName']),
		isValid () {
			return (
				this.fields.type &&
				this.fields.product &&
				this.fields.group &&
				this.fields.ASN &&
				this.fields.PO &&
				this.fields.origin &&
				this.fields.estimated_reception_date
			);
		}
	},

	watch: {
		opened () {
			if (this.opened === true) this.clearForm();
		},
		date (val) {
			this.dateInput = formatDate(val);
			this.fields.estimated_reception_date = (+new Date(val));
		}
	},

	methods: {
		parseDateInput (input) {
			const newDateNow = new Date();
			if (input && input.length === 10) {
				const parsedInput = parseDate(input);
				if (new Date(parsedInput).valueOf() > newDateNow.valueOf()) {
					return parsedInput;
				}
			}
			const newDate = newDateNow.toISOString().substring(0, 10);
			if (this.date === newDate) {
				this.dateInput = formatDate(newDate);
			}
			return newDate;
		},
		async clearForm () {
			await this.$refs.form.reset();
			const newDate = new Date();
			this.fields = {
				type: this.type,
				product: '',
				group: '',
				ASN: '',
				PO: '',
				origin: '',
				estimated_reception_date: (+newDate)
			};
			this.date = newDate.toISOString().substring(0, 10);
			this.dateInput = formatDate(newDate.toISOString());
		},
		async submit () {
			const data = this.fields;
			// Add client and service so the email can be sent with direct URL to the service
			data.clientName = this.getClientName;
			data.serviceName = this.getServiceName;
			const created = await api.post('create', data);
			await this.clearForm();
			this.$emit('removeForm', created.ops[0]);
		}
	}
};

</script>

<style lang="scss" scoped>

button.action {
	margin: 20px 10px 10px 10px;
}

button.cancel {
	margin: 20px 10px 10px 20px;
}

</style>
